/* @flow */
import React, { Component } from 'react';

import i18n from '../../../../i18n/i18n.js';

type Props = {
    lng: string,
    borderCard: string,
    backgroundCard: string,
    iconColor: string,
    borderPaypal: string,
    backgroundPaypal: string,
    changePaymentMethod: Function,
};

export default class PaymentHeader extends Component<Props> {
    render() {
        const {
            lng,
            borderCard,
            backgroundCard,
            iconColor,
            borderPaypal,
            backgroundPaypal,
        } = this.props;

        return (
            <span>
                <header>
                    <div className="headline">
                        <h4>{i18n.t('pay', { lng })}</h4>
                    </div>
                </header>
                <input
                    type="radio"
                    className="ipx-checkhid"
                    name="poption"
                    value="paypal"
                    id="paypal"
                    onChange={e => {
                        this.props.changePaymentMethod(e);
                    }}
                />
                <input
                    type="radio"
                    className="ipx-checkhid"
                    name="poption"
                    value="creditcard"
                    id="creditcard"
                    onChange={e => {
                        this.props.changePaymentMethod(e);
                    }}
                />
                <section id="priceoptions" className="two">
                    <label
                        className="payption creditcardl"
                        htmlFor="creditcard"
                        style={{
                            border: borderCard,
                            background: backgroundCard,
                        }}
                    >
                        <i
                            className="ipic_card-swipe"
                            style={{ color: iconColor }}
                        />
                        <h5>{i18n.t('credit_card', { lng })}</h5>
                    </label>

                    <label
                        className="payption paypall"
                        htmlFor="paypal"
                        style={{
                            border: borderPaypal,
                            background: backgroundPaypal,
                        }}
                    >
                        <i className="paypal" />
                    </label>
                </section>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Payments/PaymentHeader.js